import type { ReactNode } from "react";
import { IconAlert, IconCheckCircle, IconClose, IconInfo } from "../icons/icons";
import styles from "./InlineNotice.module.css";

interface InlineNoticeProps {
  tone: "error" | "info" | "success";
  children: ReactNode;
  onDismiss?: () => void;
}

const TONE_ICON = {
  error: IconAlert,
  info: IconInfo,
  success: IconCheckCircle,
} as const;

export function InlineNotice({ tone, children, onDismiss }: InlineNoticeProps) {
  const Icon = TONE_ICON[tone];
  return (
    <div className={`${styles.notice} ${styles[tone]}`} role={tone === "error" ? "alert" : "status"}>
      <Icon className={styles.icon} />
      <div className={styles.body}>{children}</div>
      {onDismiss && (
        <button type="button" className={styles.dismiss} onClick={onDismiss} aria-label="Dismiss">
          <IconClose width={16} height={16} />
        </button>
      )}
    </div>
  );
}
